// App.js
import React, { useState, useEffect } from "react";
import { Provider } from "react-redux";
import GlobalStyles from "@iso/assets/styles/globalStyle";
import { store } from "./redux/store";
import Routes from "./router";
import Maintenancef from "./containers/Pages/404/404Outside";
import AppProvider from "./AppProvider";
import ApiCall from "./library/helpers/ApiCall";
import withClearCache from "./ClearCache";

const App = () => {
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    ApiCall.get("/Setting/IsMaintenance", null, { dontLoad: true }).then((response) => {
      setMaintenance(response.data.RESULT === "1");
    });
  }, []);

  return (
    <>
      {maintenance ? (
        <Maintenancef />
      ) : (
        <Provider store={store}>
          <AppProvider>
            <>
              <GlobalStyles />
              <Routes />
            </>
          </AppProvider>
        </Provider>
      )}
    </>
  );
};

export default withClearCache(App);
